<template>
    <div id="bp-reviews" class="container-fluid">
        <div class="container">
            <div class="row">
                <h5 class="copy-heading-sub"><b>{{ component.content.label }}</b></h5>
                <h2 class="copy-heading" v-html="component.content.title"></h2>
            </div>
            <div class="row">

                <div class="col-12 col-lg-4 d-flex align-items-stretch mb-4" v-for="(review, ind) in component.content.reviews" :key="ind">

                    <div v-if="ind < 3" class="review-component d-flex flex-column justify-content-stretch w-100">
                        <div class="row justify-content-start align-items-end">
                            <div class="col-3 rate-my-agent-logo">
                                <img :src="component.content.reviewLogo" class="img-fluid" />
                            </div>
                        </div>
                        <div class="row justify-content-start align-items-start">
                            <h5 class="review-title"><b>{{ review.heading }}</b></h5>
                            <p>{{ review.copy }}</p>
                        </div>
                        <div class="row ratings justify-content-start">
                            <ul class="list-group list-group-horizontal w-50 d-flex justify-content-between align-items-center">
                                <li class="list-group-item" :class="review.stars >= 1? 'active':''"><i class="fa-solid fa-star"></i></li>
                                <li class="list-group-item" :class="review.stars >= 2? 'active':''"><i class="fa-solid fa-star"></i></li>
                                <li class="list-group-item" :class="review.stars >= 3? 'active':''"><i class="fa-solid fa-star"></i></li>
                                <li class="list-group-item" :class="review.stars >= 4? 'active':''"><i class="fa-solid fa-star"></i></li>
                                <li class="list-group-item" :class="review.stars >= 5? 'active':''"><i class="fa-solid fa-star"></i></li>

                            </ul>
                        </div>
                        <div class="row review-author">
                            <h5 class="review-name">{{ review.name }}</h5>
                            <p class="review-address">{{ review.address }}</p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row align-items-center justify-content-center">
                <router-link class="btn bp-btn" to="/reviews" aria-label="Reviews">Read more</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    // dependencies
    import shuffle from 'lodash/shuffle';

    // load assets
    import rma from "../../assets/rate-my-agent-ico.png";
    import reviewsJson from "../../json/reviews.json";

    // component vars
    let mergedReviews = []

    export default( {
        name: "reviews-component",
        components: {
            
        },
        data() {
            return {
                component: {
                    content: {
                        label:      "Reviews",
                        title:      "Kind words",
                        reviews:    null,
                        reviewLogo: rma
                    },
                    
                }
            }
        },
        methods: {
            buildReviewArr: () => {

                // get json data
                const reviewsData = reviewsJson

                // set vars
                let groupArr = []

                // limit staff reviews to 10
                Object.keys( reviewsData ).forEach(function ( data ) {

                    // set limit
                    let setLimit = 10

                    if( reviewsData[ data ].length > setLimit ) {

                        // shuffle staff reviews
                        let shuffleReviews = shuffle( reviewsData[ data ] );

                        // truncate array
                        shuffleReviews = shuffleReviews.slice( 0, setLimit )

                        // push to groupArr
                        groupArr.push( shuffleReviews )

                    } else {

                        // push to groupArr
                        groupArr.push( reviewsData[ data ] )

                    }
     
                });

                // merge staff reviews
                for ( let i = 0; i < groupArr.length; i++ ) {

                    mergedReviews = mergedReviews.concat( groupArr[i] )
                    
                }
            
            }
        },
        beforeMount () {

            this.buildReviewArr()

        },
        created() {

            setTimeout( () => {

                return this.component.content.reviews = shuffle( mergedReviews );

            }, 100 )
           
        }
    });
</script>

<style lang="scss" scoped >
    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    #bp-reviews {
        background-color:$color_base;
        padding-bottom:6em;
        padding-top:6em;
        position:relative;
        .review-component {
            background-color:$white;
            border:1px solid #00000030;
            box-shadow:0 5px 20px 2px #00000015;
            height:100%;
            margin:1em 0;
            padding:2em;
            .rate-my-agent-logo{
                margin-bottom:1em;
            }

            .review-title {
                color:$color-main;
            }

            .review-author {
                display:flex;
                flex-direction:column;
                .review-name {
                    color:$black;
                    font-size:85%;
                    font-weight: $font-weight-bold;
                    margin-bottom:0;
                }
                .review-address {
                    font-size:85%;
                    margin:0;
                }   
            }
            .ratings {
                margin:1em 0 2em;
                .list-group {
                    .list-group-item {
                        border:0;
                        border-radius:0;
                        opacity:.15;
                        padding:0;
                        &.active {
                            background-color:transparent;
                            color:$color_main;
                            opacity:1;
                        }
                    }
                }
            }
        }
        .bp-btn {
            align-items:center;
            display:flex;
            justify-content:center;
            max-width:125px;
        }
    }
</style>